import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';

// Customized Light Theme
export const hippoLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.light,
  }),
  fontFamily: '"DM Sans", sans-serif',
  defaultPageTheme: 'home',
});

// Customized Dark Theme
export const hippoDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.dark,
  }),
  fontFamily: '"DM Sans", sans-serif',
  defaultPageTheme: 'home',
});

// /* @import "~normalize.css/normalize.css"; */
// @import 'breakpoints';
// @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');
// @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');
// @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');

// @font-face {
//   font-family: 'DM Sans';
//   src: url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');
//   font-display: swap;
//   font-weight: normal;
//   font-style: normal;
// }

// :root {
//   --hippo-light-grey: #eff3f6;
//   --hippo-grey: #e5ebf0;
//   --hippo-purple: #3c1053;
//   --hippo-dark-blue: #0c2340;
//   --hippo-light-green: #005e5d;
//   --hippo-dark-green: #004c4b;
//   --hippo-pink: #ffa3b5;
//   --hippo-blue: #88dbdf;
//   --hippo-white: #ffffff;
// }

// * {
//   box-sizing: border-box;
// }

// body {
//   font-size: calc(16px + 0.3vw);
//   font-family: 'DM Sans', serif;
//   background-color: var(--hippo-light-grey);
//   color: var(--hippo-dark-blue);
//   margin: 0;
//   padding: 0;
//   line-height: 1.5;
// }

// h1 {
//   margin-bottom: 40px;
//   font-size: 3rem;
//   font-weight: 700;
//   margin-top: 0;
// }

// h2 {
//   margin-bottom: 30px;
//   font-size: 2em;
// }

// h3 {
//   margin-bottom: 20px;
//   font-size: 1.5em;
// }

// h4 {
//   margin-bottom: 16px;
//   font-size: 1.3em;
// }

// h5 {
//   margin-bottom: 10px;
//   font-size: 1.1em;
//   color: var(--hippo-purple);
// }

// h6 {
//   margin-bottom: 10px;
//   font-size: 1em;
//   color: var(--hippo-light-green);
// }

// h1,
// h2,
// h3,
// h4,
// h5,
// h6 {
//   font-weight: bold;
// }

// ol,
// ul {
//   margin-top: 0;
//   li::marker {
//     color: var(--hippo-purple);
//   }
// }

// ul {
//   li {
//     list-style-type: disc;
//     > ul > li > ul li {
//       list-style-type: circle;
//     }
//   }
// }

// a {
//   color: var(--hippo-dark-green);

//   &:visited {
//     color: var(--hippo-dark-green);
//   }
//   &:hover {
//     color: var(--hippo-purple);
//   }
// }

// input,
// label {
//   display: inline-block;
//   vertical-align: middle;
// }

// table {
//   width: 100%;
//   border-spacing: 0;
//   border: 1px solid var(--hippo-dark-blue);

//   th {
//     color: var(--hippo-white);
//     background-color: var(--hippo-dark-blue);
//     padding: 0.5em;
//   }

//   td {
//     border: 1px solid var(--hippo-dark-blue);
//     padding: 0.5rem;
//   }
// }

// button,
// input[type='submit'] {
//   font-size: 1rem;
//   padding: 0.5em 1em;
//   background: var(--hippo-light-green);
//   color: var(--hippo-white);
//   border-radius: 28px;
//   border: none;
//   font-weight: 300;
//   font-family: 'DM Sans', sans-serif;
//   cursor: pointer;
//   white-space: nowrap;

//   &:hover {
//     background-color: var(--hippo-dark-green);
//     transition: all 0.4s ease;
//     text-decoration: underline;
//   }
// }

// input[type='search' i],
// input[type='text' i] {
//   border: solid 2px var(--hippo-light-green);
//   font-size: 1rem;
//   padding: 5px 5px 5px 5px;
//   background: var(--hippo-white);
//   color: var(--hippo-light-green);
//   border-radius: 0.5em;
//   font-weight: 300;
//   font-family: 'DM Sans', sans-serif;
//   cursor: pointer;
// }

// .pill {
//   display: inline-block;
//   font-size: 0.8rem;
//   border-radius: 8px;
//   padding: 0.2rem 0.5rem;
//   margin-right: 0.4rem;
//   color: var(--hippo-white);
//   white-space: nowrap;

//   &.c-pill--success {
//     background: var(--hippo-light-green);
//   }
//   &.tag {
//     background: var(--hippo-blue);
//     color: var(--hippo-dark-blue);
//   }
// }

// .current {
//   font-weight: bold;
//   background-color: var(--hippo-pink);
//   color: var(--hippo-dark-blue);
// }

// code {
//   padding: 2px 5px;
//   background-color: var(--hippo-grey);
//   color: var(--hippo-dark-green);
//   font-size: 1.2rem;
// }

// pre {
//   line-height: 1.3;

//   code {
//     padding: 10px;
//     line-height: 1.6;
//   }
// }

// hr {
//   border-color: var(--hippo-light-green);
// }
